import { render, staticRenderFns } from "./_InstanceGroups.vue?vue&type=template&id=3ccf5d07&"
import script from "./_InstanceGroups.vue?vue&type=script&lang=ts&"
export * from "./_InstanceGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports